export enum StripeSessionType {
  PAYMENT_SETUP_SESSION = 'PAYMENT_SETUP_SESSION',
  PAYMENT_UPDATE_SESSION = 'PAYMENT_UPDATE_SESSION',
}
